import React from "react";
import "./Banner1.css";
import MainBtn from "../../MainBtn/MainBtn";

const Banner1 = (props) => {

  return (
    <div className="bannerSlider1">
      <div className="left"></div>
      <div className="right">
        <div className="txtcont">
          <h1 className="title">
            VIAJA SIN <br /> COMPLICACIONES
          </h1>
          <h2 className="text2">
            Un servicio de taxi confiable y <br /> seguro, a un click de
            distancia
          </h2>
          <MainBtn btn={props.btn} />
        </div>
      </div>
    </div>
  );
};

export default Banner1;